import React from "react";
import { IAssignCardHolder, ICardHolder, IDataCenter } from "../../../vm";
import {
  getAccessLogsConfiguration,
  getAssignCardHolders,
  getCardHolders,
  getDatacentersForACustomer,
  unAssignACardHolder,
} from "../../../services/customers/CustomerService";
import { useParams } from "react-router-dom";
import { Loading } from "../../../services/Loading";
import NoDataTile from "../../common/NoDataTile";
import {
  Stack,
  PrimaryButton,
  DetailsList,
  SelectionMode,
  DetailsListLayoutMode,
  IColumn,
  TooltipHost,
  IStackTokens,
  Modal,
  TagPicker,
  mergeStyleSets,
  Dialog,
  DialogFooter,
  DialogContent,
  DefaultButton,
  NormalPeoplePicker,
  IPersonaProps,
  ITag,
  flatten,
  IBasePickerSuggestionsProps,
  IPersonaSharedProps,
  ListPeoplePicker,
  IDetailsListProps,
  IDetailsRowStyles,
  DetailsRow,
  Text,
  Callout,
  DirectionalHint,
} from "office-ui-fabric-react";
import Icon from "@mdi/react";
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiDotsVertical,
  mdiTrashCanOutline,
} from "@mdi/js";
import { THEME } from "../../../utils/Styles";
import moment from "moment";
import {
  CUSTOMER_CARD_HOLDER_TIME_FORMAT,
  API_URL,
  childrenGap8,
} from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import CustomDrawer from "../../common/CustomDrawer";
import { assignCardHolders } from "../../../services/customers/CustomerService";
import { getToken, parseJwt } from "../../../services/UtilService";
import { stat } from "fs";
import { getAllDataCenters } from "../../../services/datacenter/DatacenterService";

export interface CardHolderProps {
  customerName: string;
}

var dcIds: string[] = [];
var dcDict: any = {};

const CardHolder: React.FC<CardHolderProps> = ({ customerName }) => {
  //hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isCardHolderFound: false,
    cardHolders: [],
    manageAssignDialog: {
      isOpen: false,
      index: undefined,
    },
    selectedItem: "",
    selectedDatacenters: [],
    tempCardHoldersList: [],
    search: {
      customerId: params.customerId,
      offset: 0,
      limit: 15,
    },
    datacenterOptions: [],
    datacenters: [],
    defDc: [],
    defCardHolder: [],
    isOnAssign: false,
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      index: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    isCardHolderFound: boolean;
    cardHolders: IAssignCardHolder[];
    manageAssignDialog: {
      isOpen: boolean;
      index?: number;
    };
    selectedItem: string;
    selectedDatacenters: string[];
    defDc: ITag[];
    defCardHolder: IPersonaProps[];
    tempCardHoldersList: ICardHolder[];
    search: {
      customerId: string;
      offset: number;
      limit: number;
    };
    datacenterOptions: ITag[];
    datacenters: IDataCenter[];
    isOnAssign: boolean;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IAssignCardHolder;
    };
  });
  const [dateFormat, setDateFormat] = React.useState("MM/DD/YYYY hh:mm:ss A" as string);

  const childrenGap24: IStackTokens = { childrenGap: 24 };
  //   const wrapStackTokens: IStackTokens = { childrenGap: 16 };
  const tokenData = parseJwt();

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getDatacenters();
    };
    asyncFunc();
  }, []);

  const getDatacenters = async () => {
    setState({ ...state, isLoading: true });
    const result = await getDatacentersForACustomer({
      customerId: params.customerId,
    });
    if (result?.success) {
      let datacenterOptions: ITag[] = [];
      result.data.forEach((d) => {
        datacenterOptions.push({
          key: d._id as string,
          name: d.name,
        });
        dcIds.push(d._id as string);
        dcDict[d._id as string] = d.name;
      });

      let obj = {
        ...state,
        datacenters: result.data,
        datacenterOptions,
        isLoading: false,
      };
      setState(obj);
      await getAllCardHolders(state.search, obj);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Error while getting datacenters", "error");
    }
  };

  const getAllCardHolders = async (searchObj?: any, paramState?: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...localState, ...paramState };
    }
    setState({ ...localState, isLoading: true });

    let tempSearch = { ...localState.search };
    if (searchObj) {
      tempSearch = { ...tempSearch, ...searchObj };
    }

    let result = await getAssignCardHolders(tempSearch);

    // get date format
    let dateFormatResp = await getAccessLogsConfiguration({
      customerId: params.customerId,
    });
    // console.log(params.customerId);
    if (result?.success) {
      // set date format
      if (dateFormatResp?.success && dateFormatResp.data.length > 0) {
        setDateFormat(dateFormatResp.data[0].dateFormat)
      } else {
        setDateFormat("MM/DD/YYYY hh:mm:ss A")
      }
      // const cardHolders: IAssignCardHolder[] = [];
      // result.data.forEach((d) => {
      //   cardHolders.push({
      //     _id: d._id,
      //     cardholderId: d.cardholderId,
      //     customerId: d.customerId,
      //     datacenterIds: d.datacenterIds,
      //     firstName: d.cardHolder && d.cardHolder.firstName,
      //     lastName: d.cardHolder && d.cardHolder.lastName,
      //     cardNumber: d.cardHolder && d.cardHolder.cardNumber,
      //     isCardEnabled: d.cardHolder && d.cardHolder.isCardEnabled,
      //     cardActivation: d.cardHolder && d.cardHolder.cardActivation,
      //     cardExpiry: d.cardHolder && d.cardHolder.cardExpiry,
      //   });
      // });
      setState({
        ...localState,
        cardHolders: result.data,
        isLoading: false,
        isCardHolderFound: true,
        search: tempSearch,
      });
    } else {
      setState({ ...localState, isLoading: false });
      showToast(result?.message || "Error while getting card holders", "error");
    }
  };

  const onUnAssign = async (item: IAssignCardHolder, index: number) => {
    showConfirmDialog(
      "Are You Sure",
      "Do you want to delete this card holder",
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            index: undefined,
            element: undefined,
            data: undefined,
          },
        });
        let result = await unAssignACardHolder(item._id as string);
        if (result.success) {
          showToast("Card holder deleted successfully", "success");
          let cardHolders = [...state.cardHolders];
          cardHolders.splice(index, 1);
          setState({
            ...state,
            cardHolders,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              index: undefined,
              element: undefined,
              data: undefined,
            },
          });
          showToast(
            result.message || "Error while deleting card holder",
            "error"
          );
        }
      }
    );
  };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      case "actions":
        return (
          <span
            onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
          >
            <Icon
              path={mdiDotsVertical}
              size={0.9}
              className="pointer"
              color="#135c8a"
            />
          </span>
          // <Stack horizontal>
          //   <TooltipHost
          //     content="Unassign"
          //     id={`deleteCh`}
          //     calloutProps={{ gapSpace: 0 }}
          //     styles={{ root: { display: "inline-block" } }}
          //   >
          //     <span onClick={() => onUnAssign(item, index)}>
          //       <Icon
          //         path={mdiTrashCanOutline}
          //         size={0.8}
          //         className="pointer"
          //         color={THEME.palette.themePrimary}
          //       />
          //     </span>
          //   </TooltipHost>
          // </Stack>
        );
      case "cardholder-name":
        return (
          <Text style={{ fontWeight: 600 }}>
            {item.cardHolder.firstName + " " + item.cardHolder.lastName}
          </Text>
        );
      case "card-status":
        return (
          <span>
            {item.cardHolder.isCardEnabled === 1 ? "Active" : "Inactive"}
          </span>
        );
      case "card-activation":
        return (
          <span>
            {item.cardHolder.cardActivation != null
              ? moment(item.cardHolder.cardActivation).format(
                dateFormat
              )
              : "Not Available"}
          </span>
        );
      case "card-expiry":
        return (
          <span>
            {item.cardHolder.cardExpiry != null
              ? moment(item.cardHolder.cardExpiry).format(
                dateFormat
              )
              : "Not Available"}
          </span>
        );
      case "datacenterIds":
        return (
          <span>
            {item.datacenterIds.length === 0
              ? "All Location"
              : item.datacenterIds.map((d: string) => dcDict[d]).join(", ")}
          </span>
        );
      case "card-number":
        return <span>{item.cardHolder.cardNumber}</span>;
      default:
        return <span>{column.fieldName ? item[column.fieldName] : ""}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  const onFilterChanged = async (
    filterText: string,
    tagList?: IPersonaProps[]
  ): Promise<IPersonaProps[]> => {
    if (filterText && filterText.length >= 2) {
      let result = await getCardHolders({
        search: filterText,
        isNewAssign: true,
      });
      if (result?.success) {
        let cardHolderTag: IPersonaProps[] = [];
        let tempCardHoldersList = [...state.tempCardHoldersList];
        result?.data.forEach((item) => {
          tempCardHoldersList.push(item);

          cardHolderTag.push({
            // key: item._id as string,
            // name: item.firstName + " " + item.lastName,
            // data:  item as IPersonaProps
            text: item.firstName + " " + item.lastName,
            secondaryText: String(item.cardNumber),
            id: item._id,
          });
        });
        // console.log("tagList", tagList);

        // tagList?.forEach((tag) => {
        //   cardHolderTag = cardHolderTag.filter((e) => e.id !== tag.id);
        // });
        if (state.cardHolders.length > 0) {
          state.cardHolders.forEach((c) => {
            cardHolderTag = cardHolderTag.filter(
              (tag) => c.cardholderId !== tag.id
            );
          });
        }
        setState({ ...state, tempCardHoldersList });
        return cardHolderTag;
      } else {
        return [];
      }
    }
    return [];
  };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    // suggestionsHeaderText: "Suggested Card holders",
    noResultsFoundText: "No Card holder found",
  };

  const datacenterPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No Datacenter found",
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let allDataCenterList = [...state.datacenterOptions];

    state.defDc.forEach((item) => {
      allDataCenterList = allDataCenterList.filter(
        (ele) => ele.key !== item.key
      );
    });

    return filterText
      ? allDataCenterList.filter(
        (tag) =>
          tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
          !listContainsTagList(tag, tagList)
      )
      : [];
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    let allDataCenterList = [...state.datacenterOptions];

    state.defDc.forEach((item) => {
      allDataCenterList = allDataCenterList.filter(
        (ele) => ele.key !== item.key
      );
    });

    // console.log(allDataCenterList);
    return removeDuplicates(allDataCenterList, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  const handleDialogOpen = (
    isOpen: boolean,
    isOnAssign?: boolean,
    index?: number
  ) => {
    let item = undefined;
    let defTag: ITag[] = [];
    let defCardHolder: IPersonaProps[] = [];
    if (isOnAssign === false) {
      if (index !== undefined) {
        item = { ...state.cardHolders[index] };
        defCardHolder.push({
          text:
            item.cardHolder &&
            item.cardHolder.firstName + " " + item.cardHolder.lastName,
          // item.cardHolder.firstName + " " + item.cardHolder &&
          // item.cardHolder.lastName,
          secondaryText: String(item.cardHolder && item.cardHolder.cardNumber),
          id: item.cardholderId,
        });
        item.datacenterIds.forEach((d) => {
          let item = state.datacenterOptions.find((dd) => dd.key === d);
          if (item) {
            defTag.push(item);
          }
        });
      }
    }
    setState({
      ...state,
      selectedItem: isOnAssign === true ? "" : (item?.cardholderId as string),
      manageAssignDialog: { isOpen, index },
      isOnAssign: isOnAssign as boolean,
      selectedDatacenters:
        isOnAssign === true ? [] : (item?.datacenterIds as string[]),
      defDc: isOnAssign === true ? [] : defTag,
      defCardHolder: isOnAssign === true ? [] : defCardHolder,
    });
  };

  const onAssign = async (
    customerId: string,
    cardholderId: string,
    datacenterIds: string[]
  ) => {
    if (cardholderId === "") {
      showToast("Select a card hoder", "error");
    }

    setState({ ...state, isLoading: true });

    let result = await assignCardHolders({
      customerId,
      cardholderId,
      datacenterIds,
    });

    if (result?.success) {
      let cardHolders = [...state.cardHolders];
      // state.tempCardHoldersList.forEach(ele=>{if(cardHolderIds?.includes(ele._id as string)){
      //     itemsToShow.push(ele)
      // })
      // state.tempCardHoldersList.forEach((ele) => {
      //   if (cardHolderIds?.includes(ele._id as string)) {
      //     cardHolders.push(ele);
      //   }
      // });
      // state.tempCardHoldersList.forEach((ele) => {
      //   cardHolderIds.map((item) => {
      //     if (item === ele._id) {
      //       cardHolders.push(ele);
      //     }
      //   });
      // });
      if (state.isOnAssign === true) {
        // cardHolderIds.map((ele) => {
        let index = state.tempCardHoldersList.findIndex(
          (item) => item._id === cardholderId
        );
        if (index !== undefined) {
          let cardHolder = { ...state.tempCardHoldersList[index] };
          let obj: IAssignCardHolder = {
            _id: result.data._id,
            cardholderId: cardHolder._id as string,
            customerId: params.customerId,
            datacenterIds: datacenterIds,
            cardHolder: cardHolder,
          };
          cardHolders.push(obj);
          // console.log(state.tempCardHoldersList);
          // console.log(state.tempCardHoldersList[index]);
        }
        // });
      } else {
        if (state.manageAssignDialog.index !== undefined) {
          cardHolders[state.manageAssignDialog.index].datacenterIds =
            datacenterIds;
        }
      }

      setState({
        ...state,
        selectedItem: "",
        defDc: [],
        selectedDatacenters: [],
        cardHolders,
        manageAssignDialog: { isOpen: false, index: undefined },
        defCardHolder: [],
        isLoading: false,
      });
      showToast("Card holder assign successfully", "success");
    } else {
      setState({ ...state, isLoading: false });
      showToast(result.message || "Can't assign Card holder", "error");
    }
  };

  const onNextOrPrevFunc = async (isNext: boolean) => {
    let searchObj = { ...state.search };
    if (isNext) {
      searchObj.offset += searchObj.limit;
    } else {
      searchObj.offset -= searchObj.limit;
    }
    await getAllCardHolders(searchObj);
  };

  const downloadCardHolderReportPdf = async () => {
    let result = await fetch(
      `${API_URL}card-holder-reports?customerId=${params.customerId}`,
      {
        method: "GET",
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    let pdf = await result.blob();
    const pdfFile = await new Blob([pdf], { type: "application/pdf" });
    const pdfFileURL = await URL.createObjectURL(pdfFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = pdfFileURL;
    a.download = `${customerName} ACTIVE CARD Holder.pdf`;
    a.click();
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IAssignCardHolder
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isCardHolderFound && (
        <Stack
          wrap
          horizontal
          tokens={childrenGap24}
          horizontalAlign="space-between"
          className="pt-16"
        >
          <Stack.Item>
            <PrimaryButton
              text="Download Report"
              disabled={
                state.isLoading === true || state.cardHolders.length === 0
              }
              onClick={() => downloadCardHolderReportPdf()}
            // className="custom-secondary-btn"
            />
          </Stack.Item>
          <Stack.Item>
            {![2, 4, 5].includes(tokenData.role) && (
              <PrimaryButton
                text="Assign"
                onClick={() => handleDialogOpen(true, true)}
                className="borderless-btn bg-white"
              />
            )}
            {state.manageAssignDialog.isOpen && (
              <CustomDrawer
                title={
                  state.isOnAssign === true
                    ? "Assign Card Holder"
                    : "Edit Card Holder"
                }
                handelOpen={true}
                onClose={() => handleDialogOpen(false)}
              >
                <Stack tokens={childrenGap24} className="pt-16">
                  <Stack.Item>
                    <NormalPeoplePicker
                      inputProps={{
                        placeholder: "Search cardholders by name/cardnumber...",
                      }}
                      itemLimit={1}
                      defaultSelectedItems={state.defCardHolder}
                      onResolveSuggestions={onFilterChanged}
                      removeButtonAriaLabel="Remove"
                      pickerSuggestionsProps={pickerSuggestionsProps}
                      disabled={state.isOnAssign !== true}
                      onChange={(items: any) => {
                        let selectedItem: string = "";
                        items.forEach((element: any) => {
                          selectedItem = element.id;
                        });
                        setState({
                          ...state,
                          selectedItem,
                          manageAssignDialog: {
                            ...state.manageAssignDialog,
                          },
                        });
                        console.log(selectedItem);
                      }}
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <TagPicker
                      removeButtonAriaLabel="Remove"
                      defaultSelectedItems={state.defDc}
                      onResolveSuggestions={filterSuggestedTags as any}
                      pickerSuggestionsProps={datacenterPickerSuggestionsProps}
                      onEmptyResolveSuggestions={showAllTags}
                      // getTextFromItem={getTextFromItem}
                      inputProps={{
                        placeholder: "Select datacenters or search by name...",
                      }}
                      onChange={(items: any) => {
                        let datacenterIds: string[] = [];
                        items.forEach((ele: any) => {
                          datacenterIds.push(ele.key);
                        });
                        setState({
                          ...state,
                          selectedDatacenters: datacenterIds,
                        });
                      }}
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={childrenGap24}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => handleDialogOpen(false)}
                        className="borderless-btn"
                      />
                      <PrimaryButton
                        text="Submit"
                        onClick={() =>
                          onAssign(
                            params.customerId,
                            state.selectedItem,
                            state.selectedDatacenters
                          )
                        }
                      />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </CustomDrawer>
            )}
          </Stack.Item>
        </Stack>
      )}
      {state.cardHolders && state.cardHolders.length > 0 ? (
        <Stack tokens={childrenGap24} className="pt-16">
          <Stack.Item>
            <DetailsList
              items={state.cardHolders}
              columns={
                ![2, 4, 5].includes(tokenData.role)
                  ? [
                    {
                      key: "cardholder-name",
                      name: "Cardholder Name",
                      fieldName: "cardholder-name",
                      minWidth: 200,
                      maxWidth: 300,
                      isResizable: true,
                    },
                    {
                      key: "card-number",
                      name: "Card Number",
                      fieldName: "cardNumber",
                      minWidth: 150,
                      maxWidth: 200,
                      isResizable: true,
                    },
                    {
                      key: "card-status",
                      name: "Card Status",
                      fieldName: "card-status",
                      minWidth: 150,
                      maxWidth: 200,
                      isResizable: true,
                    },
                    {
                      key: "card-activation",
                      name: "Card Activation",
                      fieldName: "card-activation",
                      minWidth: 200,
                      maxWidth: 300,
                      isResizable: true,
                    },
                    {
                      key: "card-expiry",
                      name: "Card Expiry",
                      fieldName: "card-expiry",
                      minWidth: 200,
                      maxWidth: 300,
                      isResizable: true,
                    },
                    {
                      key: "datacenterIds",
                      name: "Datacenters",
                      fieldName: "datacenterIds",
                      minWidth: 200,
                      maxWidth: 400,
                      isResizable: true,
                    },
                    {
                      key: "actions",
                      name: "Actions",
                      fieldName: "actions",
                      minWidth: 80,
                      maxWidth: 110,
                      isResizable: true,
                    },
                  ]
                  : [
                    {
                      key: "cardholder-name",
                      name: "Cardholder Name",
                      fieldName: "cardholder-name",
                      minWidth: 200,
                      maxWidth: 400,
                      isResizable: true,
                    },
                    {
                      key: "card-number",
                      name: "Card Number",
                      fieldName: "cardNumber",
                      minWidth: 150,
                      maxWidth: 200,
                      isResizable: true,
                    },
                    {
                      key: "card-status",
                      name: "Card Status",
                      fieldName: "card-status",
                      minWidth: 150,
                      maxWidth: 200,
                      isResizable: true,
                    },
                    {
                      key: "card-activation",
                      name: "Card Activation",
                      fieldName: "card-activation",
                      minWidth: 200,
                      maxWidth: 300,
                      isResizable: true,
                    },
                    {
                      key: "card-expiry",
                      name: "Card Expiry",
                      fieldName: "card-expiry",
                      minWidth: 200,
                      maxWidth: 300,
                      isResizable: true,
                    },
                    {
                      key: "datacenterIds",
                      name: "Datacenters",
                      fieldName: "datacenterIds",
                      minWidth: 200,
                      maxWidth: 400,
                      isResizable: true,
                    },
                  ]
              }
              compact={true}
              setKey="set"
              onRenderItemColumn={_renderItemColumn as any}
              layoutMode={DetailsListLayoutMode.justified}
              selectionMode={SelectionMode.none}
              onRenderRow={_onRenderRow}
            />
          </Stack.Item>
        </Stack>
      ) : (
        <NoDataTile title="No Card Holders Found for this Customer"></NoDataTile>
      )}
      <br />
      <Stack>
        <Stack.Item align="end" className="mr-6">
          <span
            onClick={
              state.search.offset === 0
                ? undefined
                : () => onNextOrPrevFunc(false)
            }
            className={
              state.search.offset === 0 ? "btn-disabled" : "btn-enabled pointer"
            }
          >
            <Icon
              path={mdiChevronLeft}
              size={0.9}
              className="btnIcon"
              style={{
                marginBottom: -6,
                marginRight: -8,
                color: "#135c8a",
              }}
            />
            <DefaultButton
              text="Previous"
              className="borderless-btn"
            // disabled={state.search.offset === 0}
            // onClick={() => {
            //   onNextOrPrevFunc(false);
            // }}
            />
          </span>
          <span className="nxt-prv-btn-border"></span>
          <span
            onClick={
              state.cardHolders.length < state.search.limit
                ? undefined
                : () => onNextOrPrevFunc(true)
            }
            className={
              state.cardHolders.length < state.search.limit
                ? "btn-disabled"
                : "btn-enabled pointer"
            }
          >
            <DefaultButton
              text="Next"
              className="borderless-btn"
            // disabled={state.cardHolders.length < state.search.limit}
            // onClick={() => {
            //   onNextOrPrevFunc(true);
            // }}
            />
            <Icon
              path={mdiChevronRight}
              size={0.9}
              className="btnIcon"
              style={{
                marginBottom: -6,
                marginLeft: -8,
                color: "#135c8a",
              }}
            />
          </span>
        </Stack.Item>
      </Stack>
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 115, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(
                    true,
                    false,
                    state.manageActionsCallout.index
                  );
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  onUnAssign(
                    state.manageActionsCallout.data as IAssignCardHolder,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Un-Assign
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {/* <Stack>
        <Stack.Item>
          <div className="next-prev-btn">
            <div>
              <DefaultButton
                text="Previous"
                className="mr-8"
                disabled={state.search.offset === 0}
                onClick={() => {
                  onNextOrPrevFunc(false);
                }}
              />
              <DefaultButton
                text="Next"
                disabled={state.cardHolders.length < state.search.limit}
                onClick={() => {
                  onNextOrPrevFunc(true);
                }}
              />
            </div>
          </div>
        </Stack.Item>
      </Stack> */}
    </React.Fragment>
  );
};

export default CardHolder;
